import { DeviceType } from '../service-proxies';


export class DeviceSettingDto implements IDeviceSettingDto {
    id!: number;
    deviceNo!: number;
    deviceName!: string | undefined;
    deviceType!: DeviceType;
    ipAddress!: string | undefined;
    portNo!: number;
    password!: number;
    isActive!: boolean;
    deviceSrNo!: string | undefined;

    constructor(data?: IDeviceSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deviceNo = _data["deviceNo"];
            this.deviceName = _data["deviceName"];
            this.deviceType = _data["deviceType"];
            this.ipAddress = _data["ipAddress"];
            this.portNo = _data["portNo"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.deviceSrNo = _data["deviceSrNo"];
        }
    }

    static fromJS(data: any): DeviceSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceNo"] = this.deviceNo;
        data["deviceName"] = this.deviceName;
        data["deviceType"] = this.deviceType;
        data["ipAddress"] = this.ipAddress;
        data["portNo"] = this.portNo;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["deviceSrNo"] = this.deviceSrNo;
        return data; 
    }
}

export interface IDeviceSettingDto {
    id: number;
    deviceNo: number;
    deviceName: string | undefined;
    deviceType: DeviceType;
    ipAddress: string | undefined;
    portNo: number;
    password: number;
    isActive: boolean;
    deviceSrNo: string | undefined;
}

